import { entryPoint } from "../util";
import { FrontPage } from "./front_page";

entryPoint(FrontPage);
